"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = `
query coachTrainee($id: Int!) {
  coachTrainee(id: $id) {
    hasUnseenMeal
    hasUnreadMessage
    hasUnseenTraining
    hasUnseenRecovery
    hasUnseenBehaviour
    hasUnseenMeasurement
  }
}
`;
//# sourceMappingURL=customerNotificationsQuery.js.map